(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloudinary"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const statusEl = document.getElementById('form-status');
  const fileNameEl = document.getElementById('file-name');
  const filePreview = document.getElementById('file-preview');
  const filePreviewImg = document.getElementById('file-preview-img');
  const submitBtn = document.getElementById('submit-btn');
  const submitLabel = submitBtn.querySelector('.alx-submit__label');
  const openUploadBtn = document.getElementById('open-upload-widget');
  const imageUrlInput = document.getElementById('image-url');
  const pageRoot = document.getElementById('alx-page-root');

  // Cloudinary
  const CLOUD_NAME = 'dkznc340r';
  const UPLOAD_PRESET = 'alxedo_tickets_unsigned';

  // Modales
  const modalOK = document.getElementById('alx-modal-success');
  const modalERR = document.getElementById('alx-modal-error');
  const zapIframe = document.getElementById('zapier_iframe');

  let lastFocused = null;

  function focusables(container){
    return Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'));
  }
  function openModal(modal){
    lastFocused = document.activeElement;
    if (pageRoot) pageRoot.inert = true;
    document.body.classList.add('alx-no-scroll');
    modal.hidden = false;
    const dialog = modal.querySelector('.alx-modal__dialog');
    const els = focusables(dialog);
    (els[0]||dialog).focus();
    dialog.addEventListener('keydown', modal._trap = (e)=>{
      if (e.key !== 'Tab') return;
      const fs = focusables(dialog); if(!fs.length) return;
      const [first,last] = [fs[0], fs[fs.length-1]];
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
    modal.addEventListener('click', (e)=>{ if (e.target.classList.contains('alx-modal__backdrop')) closeModal(modal); });
    modal.querySelectorAll('[data-close]').forEach(b=> b.addEventListener('click', ()=> closeModal(modal), { once:true }));
  }
  function closeModal(modal){
    modal.hidden = true;
    if (pageRoot) pageRoot.inert = false;
    document.body.classList.remove('alx-no-scroll');
    const dialog = modal.querySelector('.alx-modal__dialog');
    if (dialog && modal._trap) dialog.removeEventListener('keydown', modal._trap);
    if (lastFocused && typeof lastFocused.focus==='function') lastFocused.focus();
  }
  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape' && !modalOK.hidden) closeModal(modalOK); if(e.key==='Escape' && !modalERR.hidden) closeModal(modalERR); });

  // Validaciones amigables (Constraint Validation API)
  const form = document.getElementById('app-form');
  function setMsg(input, msg){ input.setCustomValidity(msg); input.reportValidity(); }
  form.addEventListener('input', (e)=>{
    const el = e.target;
    if (!(el instanceof HTMLInputElement)) return;
    el.setCustomValidity('');
    if (el.id==='req-fullname' && el.value && !el.validity.valid){
      setMsg(el, 'Usa solo letras y espacios (2–60).'); // Nombre
    }
    if (el.id==='req-phone'){
      el.value = el.value.replace(/\D+/g,'').slice(0,10);
      if (el.value.length===10) el.setCustomValidity('');
    }
  });

  // Widget Cloudinary
  let widget;
  function ensureWidget(){
    if (widget) return widget;
    if (!window.cloudinary?.createUploadWidget) return null;
    widget = window.cloudinary.createUploadWidget({
      cloudName: CLOUD_NAME,
      uploadPreset: UPLOAD_PRESET,
      multiple: false,
      sources: ['local'],
      folder: 'alxedo_tickets',
      maxFileSize: 10 * 1024 * 1024,
      clientAllowedFormats: ['jpg','jpeg','png','webp'],
      showCompletedButton: true
    }, (error, result) => {
      if (error) { console.error(error); statusEl.textContent = 'Error al subir.'; return; }
      if (result?.event === 'success') {
        const info = result.info;
        imageUrlInput.value = info.secure_url;
        fileNameEl.textContent = `${info.original_filename}.${info.format}`;
        filePreviewImg.src = info.secure_url;
        filePreviewImg.setAttribute('width',  info.width);
        filePreviewImg.setAttribute('height', info.height);
        filePreview.style.display = 'block';
        submitBtn.disabled = false;
        statusEl.textContent = 'Imagen subida correctamente.';
      }
    });
    return widget;
  }
  openUploadBtn?.addEventListener('click', function(){
    const w = ensureWidget();
    if (!w) { statusEl.textContent = 'Cargando uploader… intenta de nuevo.'; return; }
    w.open();
  });

  // Envío a Zapier con form nativo (sin CORS)
  document.getElementById('app-form')?.addEventListener('submit', function(e){
    e.preventDefault();

    // Validación nativa + mensajes
    const folio = document.getElementById('req-folio');
    const fullname = document.getElementById('req-fullname');
    const email = document.getElementById('req-email');
    const phone = document.getElementById('req-phone');

    const fields = [folio, fullname, email, phone];
    for (const f of fields) {
      f.setCustomValidity('');
      if (!f.checkValidity()) {
        if (f===phone) setMsg(f, 'Ingresa 10 dígitos (solo números).');
        else if (f===email) setMsg(f, 'Ingresa un correo válido (ej. nombre@dominio.com).');
        else if (f===fullname) setMsg(f, 'Usa solo letras y espacios (2–60).');
        else if (f===folio) setMsg(f, 'Letras/números, 4–32, guion o guion bajo permitido.');
        return false;
      }
    }
    if (!imageUrlInput.value){ statusEl.textContent = 'Sube una imagen antes de enviar.'; return false; }

    // Copia al form Zapier
    document.getElementById('zap-folio').value = folio.value.trim();
    document.getElementById('zap-fullname').value = fullname.value.trim();
    document.getElementById('zap-email').value = email.value.trim();
    document.getElementById('zap-phone').value = phone.value.trim();
    document.getElementById('zap-image-url').value = imageUrlInput.value;

    // Loading UI
    submitBtn.classList.add('is-loading'); submitBtn.disabled = true; statusEl.textContent = 'Enviando…';

    // Detectar retorno del iframe (éxito) con timeout de seguridad para error
    let done = false;
    const onLoad = ()=>{ if(done) return; done = true; afterSend(true); };
    const timer = setTimeout(()=>{ if(done) return; done = true; afterSend(false); }, 12000);
    zapIframe.addEventListener('load', onLoad, { once:true });

    document.getElementById('zap-form').submit();

    function afterSend(success){
      clearTimeout(timer);
      submitBtn.classList.remove('is-loading'); statusEl.textContent = '';
      if (success){
        form.reset();
        filePreview.style.display = 'none';
        fileNameEl.textContent = '';
        submitBtn.disabled = true;
        openModal(modalOK);
      }else{
        openModal(modalERR);
        submitBtn.disabled = false;
      }
    }
    return false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-sorteo-tienda"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const statusEl = document.getElementById('form-status');
  const submitBtn = document.getElementById('submit-btn');
  const pageRoot = document.getElementById('alx-page-root');

  const API_URL = (pageRoot && pageRoot.dataset.apiUrl) || 'https://sorteo-tiendas-1008228894742.us-central1.run.app';

  const modalResult = document.getElementById('alx-modal-result');
  const modalIcon = document.getElementById('alx-result-icon');
  const modalTitle = document.getElementById('alx-result-title');
  const modalText  = document.getElementById('alx-result-text');
  const modalFootnote = document.getElementById('alx-modal-footnote');

  let lastFocused = null;

  function focusables(container){
    return Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'));
  }

  function openModal(modal){
    lastFocused = document.activeElement;
    if (pageRoot) pageRoot.inert = true;
    document.body.classList.add('alx-no-scroll');
    modal.hidden = false;
    const dialog = modal.querySelector('.alx-modal__dialog');
    const els = focusables(dialog);
    (els[0]||dialog).focus();
    dialog.addEventListener('keydown', modal._trap = (e)=>{
      if (e.key !== 'Tab') return;
      const fs = focusables(dialog); if(!fs.length) return;
      const [first,last] = [fs[0], fs[fs.length-1]];
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
    modal.querySelectorAll('[data-close]').forEach(b=> b.addEventListener('click', ()=> closeModal(modal), { once:true }));
    modal.addEventListener('click', (e)=>{ if (e.target.classList.contains('alx-modal__backdrop')) closeModal(modal); });
  }

  function closeModal(modal){
    modal.hidden = true;
    if (pageRoot) pageRoot.inert = false;
    document.body.classList.remove('alx-no-scroll');
    const dialog = modal.querySelector('.alx-modal__dialog');
    if (dialog && modal._trap) dialog.removeEventListener('keydown', modal._trap);
    if (lastFocused && typeof lastFocused.focus==='function') lastFocused.focus();
  }

  document.addEventListener('keydown', (e)=>{
    if(e.key==='Escape' && !modalResult.hidden) closeModal(modalResult);
  });

  const form = document.getElementById('app-form');
  function setMsg(input, msg){ input.setCustomValidity(msg); input.reportValidity(); }

  form.addEventListener('input', (e)=>{
    const el = e.target;
    if (!(el instanceof HTMLInputElement)) return;
    el.setCustomValidity('');
    if (el.id === 'req-phone') {
      el.value = el.value.replace(/\D+/g,'').slice(0,10);
    }
  });

  function withMinDelay(startMs, minDelayMs, cb){
    const elapsed = Date.now() - startMs;
    if (elapsed >= minDelayMs) cb();
    else setTimeout(cb, minDelayMs - elapsed);
  }

  form?.addEventListener('submit', async function(e){
    e.preventDefault();

    const order    = document.getElementById('req-order');
    const fullname = document.getElementById('req-fullname');
    const email    = document.getElementById('req-email');
    const phone    = document.getElementById('req-phone');

    const fields = [order, fullname, email, phone];

    for (const f of fields) {
      f.setCustomValidity('');
      if (!f.checkValidity()) {
        if (f === phone) setMsg(f, 'Ingresa 10 dígitos (solo números).');
        else if (f === email) setMsg(f, 'Ingresa un correo válido.');
        else if (f === fullname) setMsg(f, 'Usa solo letras y espacios (2–60).');
        else if (f === order) setMsg(f, 'Letras/números, 4–32, guion o guion bajo permitido.');
        return;
      }
    }

    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;
    statusEl.textContent = 'Revisando tu suerte…';

    const start = Date.now();

    try {
      const payload = {
        order_number: order.value.trim(),
        fullname: fullname.value.trim(),
        email: email.value.trim(),
        phone: phone.value.trim()
      };

      const resp = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      let data;
      try {
        data = await resp.json();
      } catch (parseErr) {
        console.error('[SORTEO] Error parseando JSON:', parseErr);
        const text = await resp.text();
        console.log('[SORTEO] Respuesta como texto:', text);
        throw new Error('Respuesta no es JSON válido');
      }

      withMinDelay(start, 1200, () => {
        submitBtn.classList.remove('is-loading');
        statusEl.textContent = '';

        modalIcon.classList.remove('alx-modal__icon--ok','alx-modal__icon--err','alx-modal__icon--info');
        modalFootnote.textContent = '';

        if (data && data.alreadyUsed) {
          modalIcon.textContent = '!';
          modalIcon.classList.add('alx-modal__icon--info');
          modalTitle.textContent = 'Esta orden ya participó';
          modalText.textContent = data.message || 'Este número de orden ya fue usado en el sorteo.';
          modalFootnote.textContent = 'Si hiciste otra compra, utiliza el número de orden nuevo.';
          submitBtn.disabled = false;
          openModal(modalResult);
          return;
        }

        if (!data || data.success === false) {
          modalIcon.textContent = '!';
          modalIcon.classList.add('alx-modal__icon--err');
          modalTitle.textContent = 'No se pudo registrar tu participación';
          modalText.textContent = data?.message || 'Ocurrió un problema al procesar tu registro. Intenta nuevamente.';
          modalFootnote.textContent = '';
          submitBtn.disabled = false;
          openModal(modalResult);
          return;
        }

        if (data.win) {
          modalIcon.textContent = '✓';
          modalIcon.classList.add('alx-modal__icon--ok');
          modalTitle.textContent = '¡Felicidades! Ganaste';
          modalText.textContent = data.message || 'Tu participación ha resultado ganadora.';
          modalFootnote.textContent = 'Nuestro equipo se pondrá en contacto contigo con los detalles de tu premio.';
        } else {
          modalIcon.textContent = '✕';
          modalIcon.classList.add('alx-modal__icon--info');
          modalTitle.textContent = 'Registro correcto, esta vez no ganaste';
          modalText.textContent = data.message || 'Ya registramos tu participación.';
          modalFootnote.textContent = 'Cada nueva compra con un número de orden distinto es una nueva oportunidad.';
        }

        form.reset();
        submitBtn.disabled = false;
        openModal(modalResult);
      });

    } catch (err) {
      console.error('[SORTEO] Error en fetch:', err);
      withMinDelay(start, 1200, () => {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
        statusEl.textContent = 'Error de conexión. Intenta nuevamente.';

        modalIcon.textContent = '!';
        modalIcon.classList.remove('alx-modal__icon--ok','alx-modal__icon--info');
        modalIcon.classList.add('alx-modal__icon--err');
        modalTitle.textContent = 'Error de conexión';
        modalText.textContent = 'No pudimos comunicar con el servidor. Revisa tu conexión e inténtalo de nuevo.';
        modalFootnote.textContent = '';
        openModal(modalResult);
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
